<router-outlet></router-outlet>

<div id="loader" *ngIf="navigating || loading">
    <app-loading-indicator></app-loading-indicator>
    <span class="pulsate">LOADING...</span>
</div>